import { ChangeDetectionStrategy, Component } from '@angular/core';
import { Title } from '@angular/platform-browser';
import {  Router } from '@angular/router';
import { FormBuilder } from '@angular/forms';
import { AuthControlFacade } from '@medsurf/flat-facades';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { AuthControlService } from '@medsurf/flat-services';

@Component({
    selector: 'medsurf-login',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
    standalone: false
})
export class LoginComponent {

  public constructor(public titleService: Title,
                     public router: Router,
                     public authControlFacade: AuthControlFacade,
                     public fb: FormBuilder,
                     public authControlService: AuthControlService) {
    this.authControlFacade.isAuthenticated$.pipe(takeUntilDestroyed()).subscribe(async (isAuthenticated) => {
      if (isAuthenticated) {
        this.router.navigate(['/']);
      }
    });
  }

  login() {
    this.authControlService.oidcAuthLogin();
  }

  public setTitle(title: string) {
    this.titleService.setTitle(title);
    return true;
  }

}
